<template>
  <div>
    <v-menu offset-y>
      <template #activator="{ props }">
        <v-text-field
          v-model="innerValue"
          :label="label"
          readonly
          clearable
          v-bind="props"
          @click:clear="clearColor"
        >
          <template #prepend-inner>
            <div
              v-if="innerValue"
              class="color-preview rounded"
              :style="{ backgroundColor: innerValue }"
            ></div>
          </template>
        </v-text-field>
      </template>
      <v-color-picker
        v-model="innerValue"
        mode="hex"
        :modes="['hex', 'rgb']"
        show-swatches
      />
    </v-menu>
  </div>
</template>

<script>
export default {
  name: "HexColorPicker",
  props: {
    modelValue: {
      type: String,
      default: "",
    },
    label: {
      type: String,
      default: "Color",
    },
  },
  emits: ["update:modelValue"],
  computed: {
    innerValue: {
      get() {
        return this.modelValue;
      },
      set(val) {
        this.$emit("update:modelValue", val);
      },
    },
  },
  methods: {
    clearColor() {
      this.$emit("update:modelValue", "");
    },
  },
};
</script>

<style scoped>
.color-preview {
  width: 16px;
  height: 16px;
  margin-right: 8px;
  border: 1px solid rgba(0, 0, 0, 0.12);
}
</style>
